export const TETHER_LOGO =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="48" fill="#26A17B" stroke="#fff" stroke-width="4"/><path fill="#fff" d="M56 49.2v-7.7h17.6V29.8H26.5v11.7H44v7.7c-14.3.7-25 3.5-25 6.9s10.7 6.2 25 6.9V88h12V63c14.2-.7 24.9-3.5 24.9-6.9S70.2 49.9 56 49.2zm0 11.9c-.36.02-2.2.13-6.3.13-3.28 0-5.58-.09-6.4-.13-12.6-.56-22-2.76-22-5.39s9.4-4.83 22-5.4v8.6c.83.06 3.18.2 6.45.2 3.93 0 5.9-.16 6.25-.2v-8.6c12.58.57 21.95 2.77 21.95 5.4s-9.37 4.82-21.95 5.39z"/></svg>`,
  );

export const BnbLogo = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" aria-label="BNB">
    <circle cx="16" cy="16" r="16" fill="#F3BA2F" />
    <path
      fill="#fff"
      d="M12.116 14.404L16 10.52l3.886 3.886 2.26-2.26L16 6l-6.144 6.144 2.26 2.26zM6 16l2.26-2.26L10.52 16l-2.26 2.26L6 16zm6.116 1.596L16 21.48l3.886-3.886 2.26 2.259L16 26l-6.144-6.144-.003-.003 2.263-2.257zM21.48 16l2.26-2.26L26 16l-2.26 2.26L21.48 16zm-3.188-.002h.002V16L16 18.294l-2.291-2.29-.004-.004.004-.003.401-.402.195-.195L16 13.706l2.293 2.293z"
    />
  </svg>
);

export const PolygonLogo = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-label="Polygon">
    <circle cx="12" cy="12" r="12" fill="#8247E5" />
    <path
      fill="#fff"
      d="M15.9 9.6c-.28-.16-.64-.16-.95 0l-2.2 1.3-1.5.84-2.16 1.3c-.28.16-.64.16-.95 0l-1.68-1c-.28-.16-.47-.47-.47-.83v-1.94c0-.32.16-.63.47-.83l1.68-.97c.28-.16.64-.16.95 0l1.68 1c.28.16.47.47.47.83v1.3l1.5-.87v-1.33c0-.32-.16-.63-.47-.83l-3.14-1.85c-.28-.16-.64-.16-.95 0L5 7.57c-.31.17-.47.5-.47.81v3.7c0 .32.16.63.47.83l3.18 1.85c.28.16.64.16.95 0l2.16-1.26 1.5-.88 2.16-1.26c.28-.16.64-.16.95 0l1.68.97c.28.16.47.47.47.83v1.95c0 .32-.16.63-.47.83l-1.65 1c-.28.16-.64.16-.95 0l-1.68-.97c-.28-.16-.47-.47-.47-.83v-1.26l-1.5.88v1.3c0 .32.16.63.47.83l3.18 1.85c.28.16.64.16.95 0l3.18-1.85c.28-.16.47-.47.47-.83v-3.74c0-.32-.16-.63-.47-.83L15.9 9.6z"
    />
  </svg>
);

export const TronLogo = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" aria-label="TRON">
    <circle cx="16" cy="16" r="16" fill="#EF0027" />
    <path
      fill="#fff"
      d="M21.932 9.913L7.5 7.257l7.595 19.112 10.583-12.894-3.746-3.562zm-.232 1.17l2.208 2.099-6.038 1.093 3.83-3.192zm-4.9 2.985l-6.365-5.26 10.402 1.914-4.037 3.346zm-.45 1.078l-1.038 8.58L9.72 9.284l6.63 5.862zm.96.455l6.687-1.21-7.67 9.343.983-8.133z"
    />
  </svg>
);

export const TetherLogo = ({ size = 22 }) => (
  <img src={TETHER_LOGO} width={size} height={size} alt="USDT" draggable={false} />
);
